import api from './api';
import { ApiResponse } from '../types';
import { BankRow, ReconciliationResult } from '../types/fees';

/**
 * Thin service for /api/fee-reconciliation. Two endpoints, same request
 * shape: `preview` returns a dry-run classification, `commit` records
 * FeePayments for the still-matching rows.
 */

export const previewReconciliation = async (rows: BankRow[]): Promise<ReconciliationResult> => {
  const r = await api.post<ApiResponse<ReconciliationResult>>('/fee-reconciliation/preview', { rows });
  if (!r.data.success) throw new Error(r.data.message);
  return r.data.data!;
};

export const commitReconciliation = async (rows: BankRow[]): Promise<ReconciliationResult> => {
  const r = await api.post<ApiResponse<ReconciliationResult>>('/fee-reconciliation/commit', { rows });
  if (!r.data.success) throw new Error(r.data.message);
  return r.data.data!;
};

const feeReconciliationService = {
  previewReconciliation,
  commitReconciliation,
};

export default feeReconciliationService;
